import { useEffect, useState } from 'react';
import { NavLink, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import Seo from '../../components/Seo/Seo';
import HelpHeader from './HelpHeader';
import PublicBreadcrumb from '../../components/PublicBreadcrumb/PublicBreadcrumb';
import { resolveHelpIcon, helpTint, helpTintBg } from './helpDisplay';
import MissionSection from '../../components/Home/MissionSection';
import Footer from '../../components/Home/Footer';
import GDPRConsent from '../../components/Home/GDPRConsent';
import { API_BASE_URL } from '../../api';
import '../Help.scss';

const HelpCategory = () => {
	const { categorySlug } = useParams();
	const { i18n } = useTranslation();
	const [category, setCategory] = useState(null);
	const [posts, setPosts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [notFound, setNotFound] = useState(false);

	useEffect(() => {
		setLoading(true);
		setNotFound(false);
		Promise.all([
			axios.get(`${API_BASE_URL}/api/v1/help/categories/${categorySlug}`),
			axios.get(`${API_BASE_URL}/api/v1/help/categories/${categorySlug}/articles`),
		])
			.then(([categoryRes, articlesRes]) => {
				setCategory(categoryRes.data);
				setPosts(articlesRes.data);
			})
			.catch(() => setNotFound(true))
			.finally(() => setLoading(false));
	}, [categorySlug]);

	if (notFound) return <Navigate to={`/${i18n.language}/help`} replace />;
	if (loading || !category) return null;

	return (
		<div className="help-page">
			<Seo
				title={`${category.label} — Centre d'aide Saydalani`}
				description={category.description}
				path={`/${i18n.language}/help/${category.slug}`}
			/>

			<HelpHeader />
			<PublicBreadcrumb
				className="pub-crumbs--bar"
				maxWidth={1360}
				gutter="24px"
				items={[{ label: "Centre d'aide", to: `/${i18n.language}/help` }, { label: category.label }]}
			/>

			<div className="help-container help-container--article">

				<div className="help-category-header">
					<span className="help-category-header__icon" style={{ background: helpTintBg(category.color), color: helpTint(category.color) }}>
						<FontAwesomeIcon icon={resolveHelpIcon(category.icon)} />
					</span>
					<div>
						<h1>{category.label}</h1>
						<p>{category.description}</p>
					</div>
				</div>

				<div className="help-post-grid">
					{posts.map(post => (
						<NavLink key={post.id} to={`/${i18n.language}/help/${category.slug}/${post.slug}`} className="help-post-card">
							<span className="help-post-card__thumb">
								{post.imageUrl ? (
									<img src={post.imageUrl} alt="" />
								) : (
									<span
										className="help-post-card__thumb-fallback"
										style={{ background: helpTintBg(category.color), color: helpTint(category.color) }}
									>
										<FontAwesomeIcon icon={faFileLines} />
									</span>
								)}
							</span>
							<span className="help-post-card__body">
								<span className="help-post-card__title">{post.title}</span>
								<span className="help-post-card__excerpt">{post.excerpt}</span>
							</span>
						</NavLink>
					))}
				</div>
			</div>

			<MissionSection />
			<Footer />
			<GDPRConsent />
		</div>
	);
};

export default HelpCategory;
